export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';

export const createAccount = (formData: any) => ({
    form: formData,
    type: CREATE_ACCOUNT,
});
